import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {Publication} from 'asax-common';
import {ColumnMode} from '@almaobservatory/ngx-datatable';


@Component({
  selector: 'asax-result-table-cell-similarity-for-publication',
  templateUrl: './cell-similarity-for-publication.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CellSimilarityForPublicationComponent {
  @Input() publications: Publication[];

  ColumnMode = ColumnMode;
}
